import { useLayoutEffect } from 'react'

const selectorCount = selector => document.querySelectorAll(selector).length

export const useScrollLock = (isOpen, selector, toggleClass = '') => {
  useLayoutEffect(() => {
    const flag = isOpen || selectorCount(selector)
    document.body.style.overflow = flag ? 'hidden' : ''
    if (toggleClass) document.body.classList.toggle(toggleClass, flag)
    return () => {
      document.body.style.overflow = ''
      if (toggleClass) document.body.classList.remove(toggleClass)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
}
